
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {Component, NgZone, ViewChild,ElementRef, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Escenario } from 'app/main/models/escenario.model';
import { Control } from 'app/main/models/control.model';

import { first,take } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import { environment } from 'environments/environment';
import { UtilsService } from 'app/main/services/utils.service';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { AppConfig } from 'app/app-config';



@Component({
  selector: 'app-dialog-controles-criticos-print-box',
  templateUrl: './dialog-evaluacion-controles-criticos-print-box.component.html',
  styleUrls: ['./dialog-evaluacion-controles-criticos-print-box.component.scss']
})
export class DialogBoxPrintComponentEvaluacionControlesCriticos {

  action: string;
  displayedColumns: string[] = ['controles','nodo','costo','esfuerzo','riesgos','exposicionInherente','exposicionResidual','variacion'];

  dataSource: any[] = [];
  organizacion : string;
  fecha: Date = new Date();
  disabled : boolean = false;
  LOCAL_DATA: any;

  dataSourceArray: any[] = [];

  constructor(
    private _ngZone: NgZone,
    public dialogRef: MatDialogRef<DialogBoxPrintComponentEvaluacionControlesCriticos>,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    private utils: UtilsService,
    private appConfig:AppConfig,
    //private _fuseProgressBarService: FuseProgressBarService,

    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    //this.controles = data.obj;
    this.action = data.action;
    //this.organizacion = environment.cliente;
    this.organizacion = appConfig.cliente;

    this.LOCAL_DATA = {...data.obj};

    this.dataSource = [];

    /*  Con CONTROLES SUGERIDOS
    this.LOCAL_DATA.controlesSugeridos.forEach(control => {

      var linea = {control:control,
                   riesgos: [],
                   variacion: 0};

      this.LOCAL_DATA.riesgos.forEach(cs => {
        if(control.riesgo.id === cs.riesgo.id){
          var variacion = cs.topAnalisisInherente.exposicion - cs.topAnalisisResidual.exposicion;
          cs.variacion = variacion;
          if(variacion>=linea.variacion)
            linea.variacion = variacion;
          linea.riesgos.push(cs);
        }
      });

      this.dataSource.push(linea);
    });
    */

    var controlesId = [];

    this.LOCAL_DATA.riesgos.forEach(riesgo => {

      riesgo.analisisResidual.forEach(ar => {
        //if(controlesId.indexOf(ar.control) ==-1){
            controlesId.push(ar.control);
            var variacion = riesgo.topAnalisisInherente.exposicion - ar.exposicion;
            var linea = {control: ar.control,
                       riesgos: [riesgo],
                       analisisResidual: ar,
                       variacion: variacion
                       };
          if(linea.analisisResidual.control!= undefined && 
                linea.analisisResidual.control!="")
            this.dataSource.push(linea);
        /*}else{
          var lineaExist = this.findControl(ar.control);
          lineaExist.riesgos.push(riesgo);
        }*/
      });
    });


    /*
    this.dataSource.forEach(element => {

      var maxVariacion = 0;
      element.riesgos.forEach(riesgo => {
        var exposicion = riesgo.topAnalisisInherente.exposicion - riesgo.topAnalisisResidual.exposicion;
        riesgo.variacion = exposicion;
        if(exposicion>maxVariacion)
          maxVariacion = exposicion;
      });
      element.riesgos.sort((a, b) => (a.variacion < b.variacion) ? 1 : -1);
      element.variacion = maxVariacion;

    });*/

    this.dataSource.sort((a, b) => (a.variacion < b.variacion) ? 1 : -1);

    //Crear un datasource para cada rango de 40 riesgos.
    // for(var i=0; i<this.dataSource.length; i++){
      
    //   var pos = Math.trunc(i/25);
      
    //   if(i%25==0)
    //     this.dataSourceArray.push([]);
      
    //   this.dataSourceArray[pos].push(this.dataSource[i]);

    // }



  }

  findControl(control):any{
    var retorno = null;
    this.dataSource.forEach(linea => {
      if(linea.control == control)
        retorno= linea;
    });

    return retorno;
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  public printPdf()
  {
    this.disabled=true;
    this.utils.printPdf();
    this.disabled=false;

  }


}
